'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _helpers = require('../../helpers');

var _helpers2 = _interopRequireDefault(_helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GeoThermalIcon = function GeoThermalIcon(props) {
    return _react2.default.createElement(
        'svg',
        props,
        _react2.default.createElement(
            'g',
            {
                fill: 'none',
                fillRule: 'evenodd'
            },
            _react2.default.createElement('circle', {
                fill: '#FDF6E3',
                opacity: '.8',
                cx: '65',
                cy: '65',
                r: '65'
            }),
            _react2.default.createElement('path', {
                fill: '#FFF',
                d: 'M25.198 58.664V33.27L46.41 16.832h2.41l9.4 7.708 1.065-6.321h6.135v10.744l4.169 4.307v25.394zM86 38h22v20H86z'
            }),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M15 60h100v-2H15zM15 65h100v-2H15z'
                }),
                _react2.default.createElement(
                    'g',
                    {
                        stroke: '#555',
                        strokeWidth: '.6'
                    },
                    _react2.default.createElement('path', {
                        d: 'M18.941 37.822l-.912-1.182 25.562-20.06c1.771-1.391 4.452-1.391 6.225-.002L75.378 36.64l-.912 1.182-25.561-20.06c-1.254-.983-3.152-.983-4.403 0l-25.56 20.06z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M68.238 58.212h1.485V32.735h-1.485zM23.683 58.212h1.485V32.735h-1.485zM66.753 30.113h-1.485V18.499h-5.94v5.245h-1.486V17h8.911zM31.11 48.47h13.366V37.98H31.109v10.49zm-1.486 1.5H45.96V36.481H29.624v13.487z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M37.05 49.22h1.485V37.231H37.05zM63.783 58.211h-1.485v-20.23H51.9v20.23h-1.485v-21.73h13.367z'
                    }),
                    _react2.default.createElement('path', {
                        d: 'M57.842 49.22h1.485v-.997h-1.485zM41.273 115.06a6.965 6.965 0 0 1-3.694-1.074 7.345 7.345 0 0 1-3.48-6.267V79.372h1.485v28.347a5.856 5.856 0 0 0 2.776 4.994c1.66 1.035 3.597 1.139 5.305.275l.2-.105c1.81-.965 2.932-2.881 2.932-5v-9.125c0-4.098 1.827-7.164 4.887-8.202 2.325-.788 4.49-.373 6.263 1.202 1.67 1.486 2.63 3.761 2.63 6.24v5.711c0 2.13.828 4.027 2.274 5.206 1.2.98 2.677 1.344 4.164 1.024.413-.09.838-.227 1.26-.408 1.926-.829 3.17-2.817 3.17-5.067V92.005c0-1.683.52-3.292 1.462-4.535 2.493-3.288 5.416-3.163 7.431-2.48 3.06 1.039 4.885 4.103 4.885 8.202v9.126c0 2.118 1.124 4.035 2.932 5l.199.103c1.712.866 3.644.763 5.308-.274a5.852 5.852 0 0 0 2.774-4.994V79.372h1.485v22.781c0 2.566-1.3 4.91-3.478 6.268-2.08 1.296-4.604 1.425-6.752.343l-.231-.122c-2.296-1.225-3.722-3.649-3.722-6.324v-9.126c0-3.475-1.411-5.947-3.873-6.781-2.295-.778-4.184-.132-5.78 1.97-.745.982-1.155 2.27-1.155 3.624v12.46c0 2.85-1.6 5.38-4.072 6.443a8.374 8.374 0 0 1-1.534.496c-1.93.415-3.851-.054-5.408-1.323-1.795-1.466-2.824-3.788-2.824-6.372v-5.711c0-2.049-.776-3.914-2.129-5.116-1.388-1.237-2.963-1.53-4.806-.905-2.462.834-3.874 3.307-3.874 6.78v9.126c0 2.676-1.426 5.1-3.722 6.325l-.233.123a6.774 6.774 0 0 1-3.055.728M96.436 69.7h1.485V68.2h-1.485zM34.06 69.7h1.485V68.2H34.06zM96.436 75.285h1.485v-1.498h-1.485zM34.06 75.285h1.485v-1.498H34.06z'
                    })
                )
            ),
            _react2.default.createElement(
                'g',
                {
                    fill: '#555'
                },
                _react2.default.createElement('path', {
                    d: 'M86.344 58.641l-.002-.398-.01-2.267V39.784c0-.784.627-1.425 1.403-1.425h18.53c.776 0 1.403.641 1.403 1.425l-.01 16.192v2.665H86.344zm.796-.8h19.718v-1.865l.01-16.192a.615.615 0 0 0-.603-.625h-18.53a.615.615 0 0 0-.603.625v16.19l.008 1.867zm20.46.759v-1.983l.01-16.833c0-.765-.605-1.384-1.345-1.384h-18.53c-.74 0-1.345.62-1.345 1.384v16.833l.01 1.983h21.2zm.81-2.783h.99V59.4H84.6v-3.583h.99V39.784c0-1.202.96-2.184 2.145-2.184h18.53c1.185 0 2.145.982 2.145 2.184v16.033z',
                    fillRule: 'nonzero'
                }),
                _react2.default.createElement('path', {
                    d: 'M89.926 40.33h14.148c.287 0 .533.226.533.522v15.296a.527.527 0 0 1-.533.522H89.926a.527.527 0 0 1-.533-.522V40.852c0-.296.246-.522.533-.522zm.267.8v14.74h13.614V41.13H90.193zm-.267 15.47h14.148c.297 0 .526-.21.526-.452V40.852c0-.241-.23-.452-.526-.452H89.926c-.297 0-.526.21-.526.452v15.296c0 .241.23.452.526.452zm0 .8c-.725 0-1.326-.554-1.326-1.252V40.852c0-.698.601-1.252 1.326-1.252h14.148c.725 0 1.326.554 1.326 1.252v15.296c0 .698-.601 1.252-1.326 1.252H89.926z',
                    fillRule: 'nonzero'
                }),
                _react2.default.createElement('path', {
                    stroke: '#555',
                    strokeWidth: '.4',
                    d: 'M89 49h16v-1H89zM89 53h16v-1H89z'
                }),
                _react2.default.createElement('path', {
                    stroke: '#555',
                    strokeWidth: '.4',
                    d: 'M92 57h1V40h-1zM95 57h1V40h-1zM98 57h1V40h-1zM101 57h1V40h-1z'
                }),
                _react2.default.createElement('path', {
                    stroke: '#555',
                    strokeWidth: '.4',
                    d: 'M89 45h16v-1H89zM106 45h2v-1h-2zM106 41h2v-1h-2zM106 49h2v-1h-2zM106 53h2v-1h-2zM106 57h2v-1h-2zM86 41h2v-1h-2zM86 45h2v-1h-2zM86 49h2v-1h-2zM86 53h2v-1h-2zM86 57h2v-1h-2z'
                })
            )
        )
    );
};

GeoThermalIcon.defaultProps = {
    width: '130',
    height: '130',
    viewBox: '0 0 130 130',
    xmlns: 'http://www.w3.org/2000/svg'
};

var GeoThermal = function (_React$Component) {
    _inherits(GeoThermal, _React$Component);

    function GeoThermal() {
        _classCallCheck(this, GeoThermal);

        return _possibleConstructorReturn(this, (GeoThermal.__proto__ || Object.getPrototypeOf(GeoThermal)).apply(this, arguments));
    }

    _createClass(GeoThermal, [{
        key: 'render',
        value: function render() {

            var size = (0, _helpers2.default)(this.props.size || "medium", this.props.type, this.props.screenSize);

            return _react2.default.createElement(GeoThermalIcon, { width: size.width + 'px', height: size.height + 'px' });
        }
    }]);

    return GeoThermal;
}(_react2.default.Component);

exports.default = GeoThermal;